import Button from '@/components/Button';
import { ArrowLeft, ArrowRight } from '@phosphor-icons/react';
import { useEffect, useRef, useState } from 'react';

export default function Scroller({ shadow = true, children }) {
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    function handleScroll() {
      setShowLeftArrow(containerRef.current.scrollLeft > 0);
      setShowRightArrow(
        Math.ceil(
          containerRef.current.scrollLeft + containerRef.current.clientWidth
        ) +
          2 <
          containerRef.current.scrollWidth
      );
    }

    if (containerRef.current) {
      containerRef.current.addEventListener('scroll', handleScroll);
    }

    handleScroll();

    return () => {
      if (containerRef.current) {
        containerRef.current.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  function handleScrollLeft() {
    if (containerRef.current) {
      containerRef.current.scrollBy({
        top: 0,
        left: -400,
        behavior: 'smooth',
      });
    }
  }

  function handleScrollRight() {
    if (containerRef.current) {
      containerRef.current.scrollBy({
        top: 0,
        left: 400,
        behavior: 'smooth',
      });
    }
  }

  return (
    <div className="relative">
      {showLeftArrow ? (
        <div
          className="absolute top-0 left-0 h-full flex items-center"
          style={{
            width: '100px',
            background: shadow && 'rgba(255, 255, 255, 0.50)',
            borderRadius: '10px 0px 0px 10px',
          }}
        >
          <Button
            className={{
              button: {
                root: 'h-7 w-7 p-0 flex items-center justify-center border border border-brand-ai-100 rounded-full bg-white hover:bg-brand-ai-gray-500 shadow-base',
              },
            }}
            onClick={handleScrollLeft}
          >
            <ArrowLeft size={12} className="text-brand-ai-100" />
          </Button>
        </div>
      ) : null}
      <div
        ref={containerRef}
        className="flex items-center gap-1.5 overflow-y-auto whitespace-nowrap scrollbar-hide"
      >
        {children}
      </div>
      {showRightArrow ? (
        <div
          className="absolute top-0 right-0 h-full flex items-center justify-end"
          style={{
            width: '100px',
            background: shadow && 'rgba(255, 255, 255, 0.50)',
            borderRadius: '10px 0px 0px 10px',
          }}
        >
          <Button
            className={{
              button: {
                root: 'h-7 w-7 p-0 flex items-center justify-center border border border-brand-ai-100 rounded-full bg-white hover:bg-brand-ai-gray-500 shadow-base',
              },
            }}
            onClick={handleScrollRight}
          >
            <ArrowRight size={12} className="text-brand-ai-100" />
          </Button>
        </div>
      ) : null}
    </div>
  );
}
